const loader = `
  <div class="d-flex justify-content-center my-5">
    <div class="spinner-border s-2" style="width: 3.5rem; height: 3.5rem; color: #FF0048" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
`;
export default loader;
